import { render, staticRenderFns } from "./create-v2.vue?vue&type=template&id=f438f07e&"
import script from "./create-v2.vue?vue&type=script&lang=js&"
export * from "./create-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports